import { useEffect, useState } from "react";
import type { ObjectId } from "@mind-sands/shared";
import { api } from "../api";
import {
  enqueueThumbnail,
  getCachedThumbnail,
  subscribeThumbnails,
} from "../lib/modelThumbnails";

/** Subscribe to the offscreen thumbnail cache for a single model. */
export function useModelThumbnail(modelId: string): string | undefined {
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    if (getCachedThumbnail(modelId)) return;
    const unsubscribe = subscribeThumbnails(() => forceUpdate((n) => n + 1));

    api.resolveModelUrl(modelId as ObjectId, "thumb").then((url) => {
      enqueueThumbnail(modelId, url);
    });

    return unsubscribe;
  }, [modelId]);

  return getCachedThumbnail(modelId);
}
